exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host {\n  position: relative;\n  width: 100%; }\n  :host > .inner {\n    position: relative;\n    display: inline-block;\n    height: 100%;\n    left: 50%;\n    transform: translateX(-50%); }\n  :host .box {\n    margin: 0 3px;\n    width: 48px;\n    font-size: 10px; }\n\n.cursor-pointer {\n  cursor: pointer; }\n", ""]);

